var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
      [
        _c("c-table", {
          ref: "grid1",
          attrs: {
            title: "감사기준",
            tableId: "grid1",
            columnSetting: false,
            isFullScreen: false,
            usePaging: false,
            filtering: false,
            hideBottom: true,
            columns: _vm.grid1.columns,
            data: _vm.grid1.data,
          },
          on: { rowClick: _vm.rowClick },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8" },
      [
        _c("c-table", {
          ref: "grid2",
          attrs: {
            title: "감사기준별 감사항목",
            tableId: "grid2",
            columnSetting: false,
            isFullScreen: false,
            usePaging: false,
            filtering: false,
            hideBottom: true,
            columns: _vm.grid2.columns,
            data: _vm.grid2.data,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }